<template>
  <div
    v-if="showLoadingState < 3"
    key="loadingState"
    class="m-initial-loading"
  >
    <AtomLoadingPrimary/>
  </div>
  <div
    v-else
    class="m-card-primary m-the-modal-content m-edition-billing-my-payments-modal-change-plan">
    <form
      autocomplete="off"
      name="the-modal-form"
      @submit.prevent="cambioPlan()"
    >
      <header class="m-the-modal-header">
        <h5>{{ $modal.element.producto.nombre }}</h5>
        <AtomButtonTheModalCloseIcon/>
      </header>
      <section class="m-the-modal-section-height-auto">
        <p
          v-for="pasarela in gateways"
          :key="pasarela.id_academia_pasarela_pago"
          class="margin-bottom-large margin-top-large"
        >
          <label class="display-flex-row a-radiobutton-primary a-radiobutton-billing-primary width-100-pr">
            <input
              v-model="$modal.element.pasarela"
              class="a-radiobutton-primary a-radiobutton-billing-primary"
              name="medioPago"
              type="radio"
              :value="pasarela.id_academia_pasarela_pago"
            >
            <span class="a-radiobutton-checkmark"></span>
            <span class="margin-left-xsmall">
              {{ findGatewayById(pasarela.pasarela_pago).nombre_publico }}
            </span>
            <span class="margin-left-auto">
              <img
                :alt="findGatewayById(pasarela.pasarela_pago).nombre"
                :src="require(`@/assets/img/gateways/${findGatewayById(pasarela.pasarela_pago).nombre.toLowerCase().replace(' ', '')}.png`)"
              >
            </span>
          </label>
        </p>
        <p>
          <label
            v-if="cliente.comprobanteTipo !== 1"
            class="display-flex-row a-checkbox-primary a-checkbox-billing-primary">
            <input
              v-model="cliente.factura_completa"
              class="a-checkbox-primary a-checkbox-input-billing-primary"
              name="necesitaFactura"
              type="checkbox"
              :value="+(cliente.comprobanteTipo !== 1 && (cliente.factura_completa || quotedPrice > 3000))"
              :checked="cliente.factura_completa"
              :disabled="quotedPrice > 3000"
            />
            <span class="a-checkbox-checkmark"></span>
            <span class="margin-left-xsmall">
              {{ $t('mEditionBillingMyPaymentModalChangePlan.checkFacturaCompleta') }}
            </span>
          </label>
          <div
            v-if="cliente.factura_completa && cliente.comprobanteTipo !== 1"
            class="m-container-primary margin-left-xxlarge margin-top-small"
          >
            <div class="row">
              <div class="column column-12">
                <div class="display-flex-row">
                  <AtomRadioButtonPrimary
                    v-model.number="cliente.fisica"
                    :radio-button-primary="radioButtonPrimary.facturaCompleta.tipoPersona"
                    :text="$t('mEditionBillingMyPaymentModalChangePlan.inputs.persona.particular.label')"
                    :value="1"
                    wrapperClass="a-input-side margin-top-xsmall margin-bottom-xsmall"
                  />
                  <AtomRadioButtonPrimary
                    v-model.number="cliente.fisica"
                    :radio-button-primary="radioButtonPrimary.facturaCompleta.tipoPersona"
                    :text="$t('mEditionBillingMyPaymentModalChangePlan.inputs.persona.empresa.label')"
                    :value="0"
                    wrapperClass="a-input-side margin-top-xsmall margin-bottom-xsmall"
                  />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="column column-4">
                <AtomSelectPrimary
                  v-model.number="cliente.documento.tipo"
                  :input-error="$v.cliente.documento.tipo.$error"
                  :elements="documentoTipos"
                  key-field="id_documento_tipo"
                  name="documento_tipo"
                  reference="documento_tipo"
                  :message-error="messageErrorTipoDoc"
                  input-class="font-size-xsmall"
                  text-field="nombre"
                  wrapperClass="a-input-wrapper-column margin-top-medium font-size-xsmall"
                  @blur="$v.cliente.documento.tipo.$touch()"
                />
              </div>
              <div class="column column-8">
                <AtomInputPrimary
                  v-model="cliente.documento.numero"
                  :input-error="$v.cliente.documento.numero.$error"
                  input-class="font-size-xsmall"
                  name="documento_numero"
                  reference="documento_numero"
                  :message-error="messageErrorDocumentoNum"
                  :placeholder="$t('mEditionBillingMyPaymentModalChangePlan.inputs.documento_numero.placeholder')"
                  type="text"
                  wrapper-class="margin-zero font-size-xsmall"
                  @blur="$v.cliente.documento.numero.$touch()"
                />
              </div>
            </div>
            <div class="row">
              <div class="column column-12">
                <AtomInputPrimary
                  v-model="cliente.domicilio.linea1"
                  :input-error="$v.cliente.domicilio.linea1.$error"
                  input-class="font-size-xsmall"
                  name="direccion"
                  reference="direccion"
                  :message-error="messageErrorDireccion"
                  :placeholder="$t('mEditionBillingMyPaymentModalChangePlan.inputs.direccion.placeholder')"
                  type="text"
                  wrapper-class="font-size-xsmall margin-zero"
                  @blur="$v.cliente.domicilio.linea1.$touch()"
                />
              </div>
            </div>
            <div class="row">
              <div class="column column-8">
                <AtomInputPrimary
                  v-model="cliente.domicilio.localidad"
                  :input-error="$v.cliente.domicilio.localidad.$error"
                  input-class="font-size-xsmall"
                  name="localidad"
                  reference="localidad"
                  :message-error="messageErrorlocalidad"
                  :placeholder="$t('mEditionBillingMyPaymentModalChangePlan.inputs.localidad.placeholder')"
                  type="text"
                  wrapper-class="font-size-xsmall margin-zero"
                  @blur="$v.cliente.domicilio.localidad.$touch()"
                />
              </div>
              <div class="column column-4">
                <AtomInputPrimary
                  v-model="cliente.domicilio.codigo_postal"
                  :input-error="$v.cliente.domicilio.codigo_postal.$error"
                  input-class="font-size-xsmall"
                  :message-error="messageErrorCodigoPostal"
                  name="codigo_postal"
                  reference="codigo_postal"
                  :placeholder="$t('mEditionBillingMyPaymentModalChangePlan.inputs.codigo_postal.placeholder')"
                  type="text"
                  wrapper-class="font-size-xsmall margin-zero"
                  @blur="$v.cliente.domicilio.codigo_postal.$touch()"
                />
              </div>
            </div>
          </div>
        </p>
        <p>
          <label class="display-flex-row a-checkbox-primary a-checkbox-billing-primary">
            <input
              v-model="tieneCupon"
              class="a-checkbox-primary a-checkbox-input-billing-primary"
              name="tieneCupon"
              type="checkbox"
              :value="tieneCupon"
              :disabled="plan.id_producto_gestion_plan !== $modal.element.plan.id_producto_gestion_plan"
            />
            <span class="a-checkbox-checkmark"></span>
            <span class="margin-left-xsmall">
              {{ $t('mEditionBillingMyPaymentModalChangePlan.checkCupon') }}
            </span>
          </label>
          <span
            class="display-flex-row margin-left-xxlarge margin-top-small"
            v-show="tieneCupon"
          >
            <AtomInputPrimary
              v-model="cuponDescuento.codigo"
              input-class="font-size-xsmall margin-left-medium"
              name="cupon"
              :placeholder="$t('mEditionBillingMyPaymentModalChangePlan.inputs.cupon.placeholder')"
              reference="cupon"
              type="text"
              wrapper-class="font-size-xsmall margin-zero"
            />
            <a
              href="#"
              class="a-button-primary a-button-academy-primary font-size-xsmall margin-left-small"
              @click.prevent="updateVentaCuponDescuento()"
            >
              <i :class="btnCuponSending ? 'far fa-spinner fa-spin' : ''"></i>
              Aplicar
            </a>
          </span>
        </p>
        <p class="font-size-large margin-top-xsmall">
          <i class="far fa-shopping-cart margin-right-xsmall"></i>
            {{ $t('mEditionBillingMyPaymentModalChangePlan.lblTotal')}}
          <span
            v-if="plan.id_producto_gestion_plan !== $modal.element.plan.id_producto_gestion_plan"
            class="font-size-small text-color-billing-primary"
            style="text-decoration:line-through;"
          >
              {{divisaSelected.simbolo}}{{$modal.element.plan.pago.precio}} {{ divisaSelected.iso_code }}</span>
          <span class="font-weight-bold text-color-billing-primary">
            {{ divisaSelected.simbolo }}{{ plan.pago.precio }}
            {{ divisaSelected.iso_code }}
            {{ `cada ${$filters.getFrequencyValue(plan.pago.frecuencia, 'name')}` }}
          </span>
        </p>
      </section>
      <footer class="m-the-modal-footer">
        <AtomButtonTheModalCancelAction :cancel-text="$t('mEditionBillingMyPaymentModalChangePlan.buttonCancel')"/>
        <AtomButtonPrimary :button-primary="buttonPrimary"/>
      </footer>
    </form>
  </div>
</template>

<script>
import { maxLength, minLength, required } from 'vuelidate/lib/validators'

export default {
  name: 'MoleculeEditionBillingMyPaymentsModalChangePlan',

  data () {
    return {
      btnCuponSending: false,
      buttonPrimary: {
        action: this.$t('mEditionBillingMyPaymentModalChangePlan.buttonPrimary'),
        class: 'a-button-billing-primary',
        sending: false,
        type: 'submit'
      },

      cuponDescuento: {
        producto: this.$modal.element.producto.id,
        codigo: ''
      },

      cliente: {
        comprobanteTipo: '',
        domicilio: {
          codigo_postal: this.$modal.element.cliente.datos_personales && this.$modal.element.cliente.datos_personales.domicilio
            ? this.$modal.element.cliente.datos_personales.domicilio.codigo_postal
            : '',
          linea1: this.$modal.element.cliente.datos_personales && this.$modal.element.cliente.datos_personales.domicilio
            ? this.$modal.element.cliente.datos_personales.domicilio.linea1
            : '',
          localidad: this.$modal.element.cliente.datos_personales && this.$modal.element.cliente.datos_personales.domicilio
            ? this.$modal.element.cliente.datos_personales.domicilio.localidad
            : ''
        },
        documento: {
          numero: this.$modal.element.cliente.datos_personales &&
          this.$modal.element.cliente.datos_personales.documento &&
          this.$modal.element.cliente.datos_personales.documento.numero !== 0
            ? this.$modal.element.cliente.datos_personales.documento.numero
            : '',
          tipo: this.$modal.element.cliente.datos_personales && this.$modal.element.cliente.datos_personales.documento
            ? this.$modal.element.cliente.datos_personales.documento.tipo.id_documento_tipo
            : ''
        },
        factura_completa: +(this.$modal.element.venta.detalle && this.$modal.element.venta.detalle.comprobante.facturaCompleta),
        fisica: +(this.$modal.element.cliente.datos_personales && this.$modal.element.cliente.datos_personales.fisica)
      },

      divisaSelected: this.$modal.element.divisa,

      documentoTipos: [],

      plan: this.$modal.element.plan,

      pasarelas: [],

      pasarelaSelected: null,

      quotedPrice: '',

      radioButtonPrimary: {
        facturaCompleta: {
          tipoPersona: {
            labelClass: 'a-radiobutton-billing-primary font-size-xsmall',
            name: 'tipo-de-persona'
          }
        }
      },
      showLoadingState: 0,

      tieneCupon: false
    }
  },

  validations: {
    cliente: {
      documento: {
        numero: {
          maxLength: maxLength(30),
          minLength: minLength(3),
          required
        },

        tipo: {
          required
        }
      },

      domicilio: {
        codigo_postal: {
          required
        },

        linea1: {
          maxLength: maxLength(120),
          minLength: minLength(5),
          required
        },

        localidad: {
          maxLength: maxLength(60),
          required
        }
      }
    }
  },

  computed: {
    gateways () {
      return [...this.$modal.element.gateways]
    },

    messageErrorCodigoPostal () {
      return this.$validation.getValidationMessage('mEditionBillingMyPaymentModalChangePlan', this.$v.cliente.domicilio.codigo_postal, 'cliente', 'codigo_postal')
    },

    messageErrorDireccion () {
      return this.$validation.getValidationMessage('mEditionBillingMyPaymentModalChangePlan', this.$v.cliente.domicilio.linea1, 'cliente', 'direccion')
    },

    messageErrorDocumentoNum () {
      return this.$validation.getValidationMessage('mEditionBillingMyPaymentModalChangePlan', this.$v.cliente.documento.numero, 'cliente', 'documento_numero')
    },

    messageErrorlocalidad () {
      return this.$validation.getValidationMessage('mEditionBillingMyPaymentModalChangePlan', this.$v.cliente.domicilio.localidad, 'cliente', 'localidad')
    },

    messageErrorTipoDoc () {
      return this.$validation.getValidationMessage('mEditionBillingMyPaymentModalChangePlan', this.$v.cliente.documento.tipo, 'cliente', 'documento_tipo')
    }
  },

  watch: {
    quotedPrice () {
      if (this.quotedPrice > 3000 && this.cliente.comprobanteTipo !== 1) {
        this.cliente.factura_completa = true
      }
    }
  },

  created () {
    this.readParametroCotizacion(this.plan)
    this.readPasarelas()
    this.readParametroDocumentoTipos()
  },

  methods: {
    cambioPlan () {
      let valid
      if (this.cliente.factura_completa) {
        this.$v.$touch()
        this.$nextTick(() => this.$validation.focusInputError(this))
        valid = this.$v.$invalid
      } else {
        valid = false
      }
      if (!this.buttonPrimary.sending && !valid) {
        this.buttonPrimary.sending = true
        this.$services.create('ventas', 'changePlan', Object.assign(
          {},
          { academia: this.$store.getters.getAcademyData.id },
          { producto: this.$modal.element.producto.id },
          { plan: this.plan.id_producto_gestion_plan },
          { pasarela: this.$modal.element.pasarela },
          { cliente: this.cliente }), [ this.$modal.element.venta.id_venta ])
          .then(response => {
            this.$utils.isUrl(response.data)
              ? window.location.replace(response.data)
              : this.findGatewayById(this.$modal.element.gateways.find(pp => pp.id_academia_pasarela_pago === this.$modal.element.pasarela).pasarela_pago).nombre === 'Paypal'
                ? this.$paypal.formPaypal(JSON.parse(response.data))
                : this.$stripe.init(Object.assign(
                  {},
                  { stripeAccount: this.$modal.element.gateways.find(pp => pp.id_academia_pasarela_pago === this.$modal.element.pasarela).configuracion['id'] },
                  { sessionId: response.data })
                )
            this.buttonPrimary.sending = false
            this.$modal.closeModal()
            this.showLoadingState++
          })
          .catch(error => {
            this.showLoadingState++
            this.$alerts.pushAlert('mEditionBillingMyPaymentModalChangePlan', 'changePlan', 'error', 'a-alert-danger')
            this.buttonPrimary.sending = false
            this.$modal.closeModal()
            console.log(error)
          })
      }
    },

    findGatewayById (id) {
      return this.pasarelas.find(gw => gw.id === id)
    },

    readPasarelas () {
      this.$services.read('pasarela', 'readPasarelas')
        .then(response => {
          this.pasarelas = response.data
          this.pasarelaSelected = this.$modal.element.pasarela
            ? this.pasarelas.find(p => { return p.nombre === this.$modal.element.pasarela }).id
            : null
          this.showLoadingState++
        })
        .catch(error => {
          console.log(error)
        })
    },

    readParametroCotizacion (plan, cupon = false) {
      this.$services.read('parametro', 'readParametroCotizacion', {}, [plan.id_producto_gestion_plan])
        .then(response => {
          this.quotedPrice = response.data.precio_cotizado
          this.cliente.comprobanteTipo = response.data.comprobante_tipo
          if (cupon) {
            this.plan = plan
            this.$alerts.pushAlert('mEditionBillingMyPaymentModalChangePlan', 'cupon', 'success')
            this.btnCuponSending = false
          }
          this.showLoadingState++
        })
        .catch(error => {
          console.log(error)
          this.showLoadingState++
        })
    },

    readParametroDocumentoTipos () {
      this.$services.read('parametro', 'readParametroDocumentoTipos', {}, [this.$modal.element.cliente.datos_personales.domicilio.provincia.pais.id_pais])
        .then(response => {
          this.documentoTipos = response.data
          this.showLoadingState++
        })
        .catch(error => {
          console.log(error)
          this.documentoTipos = []
          this.showLoadingState++
        })
    },

    show (index) {
      this.questions[index].show = !this.questions[index].show
    },

    updateVentaCuponDescuento () {
      if (!this.btnCuponSending) {
        this.btnCuponSending = true
        this.$services.create('ventas', 'updateVentaCuponDescuento', this.cuponDescuento)
          .then(response => {
            let gestion = response.data.gestiones.find(g => g.divisa.id_divisa === this.divisaSelected.id_divisa)
            let planDescuento = gestion ? gestion.planes.find(p => p.plan_original.id_producto_gestion_plan === this.$modal.element.plan.id_producto_gestion_plan) : this.plan
            this.readParametroCotizacion(planDescuento, true)
          })
          .catch(error => {
            console.log(error)
            this.$alerts.pushAlert('mEditionBillingMyPaymentModalChangePlan', 'cupon', 'error', 'a-alert-danger')
            this.btnCuponSending = false
          })
      }
    }
  }
}
</script>
